import React, { useState } from "react";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
// import CheckBox from "@material-ui/core/CheckBox";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import Collapse from "@material-ui/core/Collapse";
import CardContent from "@material-ui/core/CardContent";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import makeStyles from "@material-ui/core/styles/makeStyles";
import "@fontsource/montserrat";
import requestMentor from "../../../../../assets/images/request-mentor.png";
import requestImage from "../../../../../assets/images/tm-1.jpg";
import linewitdot from "../../../../../assets/svg/dashboard/Line wit Dot.svg";
import dropdownicon from "../../../../../assets/images/arrow.png";
import mentorimage from "../../../../../assets/images/tm-3.jpg";
import orgimage from "../../../../../assets/images/platinum-mentor.png";
import ReactStars from 'react-rating-stars-component';
import "./style.scss";
import { width } from "@mui/system";

const firstExample = {
  size: 40,
  count: 5,
  isHalf: false,
  paddingLeft:25,
  value: 1,
  color: 'gray',
  activeColor: 'orange',
  onChange: (newValue) => {
    
  },
};
const secondExample = {
  size: 40,
  count: 5,
  isHalf: false,
  value: 2,
  color: 'gray',
  // boxShadow: '1px 2px 9px #F4AAB9',
  // boxShadow: "-10px 13px 30.5px 0 red",
  activeColor: 'orange',
  // background-image: linear-gradient(#fdc163, #f78f54) !important;
  onChange: (newValue) => {
    
  },
};
const thirdExample = {
  size: 40,
  count: 5,
  isHalf: false,
  paddingLeft:25,
  value: 3,
  color: 'gray',
  activeColor: 'orange',
  
  onChange: (newValue) => {
    
  },
};
const fourthExample = {
  size: 40,
  count: 5,
  isHalf: false,
  paddingLeft:25,
  value: 4,
  color: 'gray',
  activeColor: 'orange',
  onChange: (newValue) => {
    
  },
};
const useStyles = makeStyles((theme) => ({
  firstHeading: {
    fontFamily: "Montserrat",
    fontWeight: "bold",
    color: "rgba(0,0,0,0.5)",
    fontSize: "18px",
  },
  secondHeading: {
    fontFamily: "Montserrat",
    color: "#6f59a6",
    fontSize: "40px",
    fontWeight: "bold",
  },
  upperDisplay: {
    width: "86%",
    marginTop: "25px",
    padding: "25px",
    background:
      "linear-gradient(90deg, rgba(247,243,255,1) 0%, rgba(222, 212, 245,0.8130602582830007) 100%)",
    // background:
    //   "linear-gradient(90deg, rgba(247,243,255,1) 0%, rgba(222, 212, 245,0.8130602582830007) 100%)",
  },
  headingthreeone: {
    fontSize: "16px",
    color: "#6f59a6",
    fontWeight: 600,
    fontFamily: "Montserrat",
  },
  headingthreetwo: {
    fontSize: "16px",
    fontWeight: "bold",
    fontFamily: "Montserrat",
    color: "#3AC2D7 !important",
  },
  showInMiddle: {
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  filterContainer: {
    padding: "50px 22%",
  },
  select: {
    fontSize: "16px",
    width: "200px",
  },
  selectContainer: {
    display: "flex",
    justifyContent: "right",
    [theme.breakpoints.down("md")]: {
      marginBottom: "10px",
    },
  },
  cardroot: {
    paddingTop: "30px",
    // background:
    // "linear-gradient(256deg, rgba(244,240,255,1) 0%, rgba(211,191,255,0.55) 100%)",
    background:
      "linear-gradient(77deg, #d9c5e789 0%, #f4f4f4 74%)",
      
  },
  cardImage: {
    height: "120px",
    width: "120px",
    objectFit: "cover",
    borderRadius: "5px",
    boxShadow: "3px 4px 13px -4px rgba(0,0,0,0.75)",
    objectFit: 'contain'
  },
  cardText1: {
    paddingTop: "30px",
    fontSize: "18px",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    color: "#6f59a6",
                  opacity: 0.9
  },
  cardText3: {
    paddingTop: "14px",
    fontSize: "18px",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    color: "#6f59a6",
                  opacity: 0.9
  },
  cardText2: {
    fontSize: "26px",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    color: "#6f59a6",
  },
  circularDisplay: {
    height: "50px",
    width: "50px",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background:
      "linear-gradient(45deg, rgba(83,255,250,1) 0%, rgba(118,95,170,1) 100%)",
    color: "#fff",
    fontWeight: 'bold'
  },
  viewProfileButton: {
    transition: "0.5s",
    "&:hover": {
      transform: "translateY(-10px)",
    },
  },
  rightRotated: { transform: "rotate(-90deg)" },
  upperDisplayImage: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      marginBottom: "30px",
    },
  },
  mobileMarginForUpperDisplayGrids: {
    [theme.breakpoints.down("md")]: {
      marginBottom: "30px",
    },
  },
  checkboxRoot: {
    color: "#3AC2D7 !important",
  },
}));

// #b499c7
// #3e4a59

const DisplaySurface = (props) => {
  const classes = useStyles();

  return (
    <Box  className="mentorFeedback-line" sx={{ position: "relative", width: "100%" }}>
      <Box className={classes.Container}>
        <img
          src={linewitdot}
          alt="line with dot"
          className={classes.lineWithDot}
        />
      </Box>
      <Box
        style={{
          position: "absolute",
          height: "40px",
          left: "0px",
          top: "50%",
          transform: "translateY(-50%)",
          // display:"flex",
          fontSize:"12px",
          textTransform:"uppercase",
          backgroundColor: "#a495c6",
          borderRadius: "6px",
          display: "flex",
          justifyContent: "center",
          paddingLeft:"2px",
          paddingRight:"2px",
          alignItems: "center",
          color: "#fff",
          width: "80% ",
        }}
      >
        {props.content}
      </Box>
    </Box>
  );
};
const ImageDisplaySurface = (props) => {
  const classes = useStyles();

  return (
    <Box className="box-ImageDta" sx={{ position: "relative",  }}>
      <Box className={classes.Container}>
        <img
        style={{width:"100px"}}
          src={linewitdot}
          alt="line with dot"
          className={classes.lineWithDot}
        />
      </Box>
      <Box
        style={{
          position: "absolute",
          height: "40px",
          left: "0px",
          top: "50%",
          transform: "translateY(-50%)",
          // display:"flex",
          fontSize:"12px",
          textTransform:"uppercase",
          // backgroundColor: "#a495c6",
          borderRadius: "6px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: "#fff",
          width: "80% ",
        }}
      >
        {props.content}
      </Box>
    </Box>
  );
};

const UpperDisplaySurface = () => {
  const classes = useStyles();

  return (
    <div className="feedback-content">
       <Box style={{ width: "100%", display: "flex", justifyContent: "center" }}>
      <Paper elevation={3} className={classes.upperDisplay}>
        <Grid container>
        <Grid item container spacing={1} xs={12} md={6}>
          <Grid item xs={12}  md={4} className={classes.upperDisplayImage}>
            <img
              style={{ height: "100px" }}
              src={requestMentor}
              alt="peopleweblogo"
            />
            </Grid>
            <Grid
              item
              xs={12}  md={4}
              className={classes.mobileMarginForUpperDisplayGrids}
            >
              
              <Box  className={classes.showInMiddle}>
                <DisplaySurface content={"MENTOR FEEDBACK"} />
              </Box>
            </Grid>
            <Grid
              item
              xs={12} md={4}
              className={classes.mobileMarginForUpperDisplayGrids}
            >
              
              <Box className={classes.showInMiddle}>
                <ImageDisplaySurface content={<img
              
              src={requestImage}
              alt="peopleweblogo"
            />} />
              </Box>
            </Grid>

          </Grid>
          <Grid className="Fdback-TbleData" item container spacing={1} xs={12} md={6}>
           
         
            <Grid
              item
              xs={12}
              md={3}
              className={classes.mobileMarginForUpperDisplayGrids}
            >
              <Typography className={classes.headingthreeone}>
               NAME
              </Typography>
              <Box className={classes.showInMiddle}>
                <Typography className={classes.headingthreetwo}>
                  SHRIDHAR RAJAN
                </Typography>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              md={3}
              className={classes.mobileMarginForUpperDisplayGrids}
            >
              <Typography className={classes.headingthreeone}>
                COUNTRY
              </Typography>
              <Box className={classes.showInMiddle}>
                <Typography className={classes.headingthreetwo}>
                  INDIA
                </Typography>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              md={3}
              className={classes.mobileMarginForUpperDisplayGrids}
            >
              <Typography className={classes.headingthreeone}>STATE</Typography>
              <Box className={classes.showInMiddle}>
                <Typography className={classes.headingthreetwo}>
                  MAHARASHTRA
                </Typography>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              md={3}
              className={classes.mobileMarginForUpperDisplayGrids}
            >
              <Typography className={classes.headingthreeone}>
                CITY
              </Typography>
              <Box className={classes.showInMiddle}>
                <Typography className={classes.headingthreetwo}>
                  MUMBAI
                </Typography>
              </Box>
            </Grid>
           
          </Grid>
        </Grid>
      </Paper>
    </Box>
   
    <div className="feedback-rating">
    <div  className="row ">
<div style={{textAlign:"right"}} className="col col-lg-1 col-md-1 col-sm-2 col-2 numdata">1</div>
<div className="col col-lg-6 col-md-5 col-sm-10 col-10 rating-line">Overall Mentor Rating</div>
<div style={{textAlign:"left",marginTop:"-15px"}} className="col col-lg-5 col-md-6 col-sm-12  col-12 reactstart" ><ReactStars {...firstExample} /></div>

    </div>
    <div className="row ">
<div style={{textAlign:"right"}} className="col col-lg-1 col-md-1 col-sm-2 col-2 numdata">2</div>
<div  className="col col-lg-6 col-md-5 col-sm-10 col-10 rating-line">Mentor Behaviour & Professionalism</div>
<div style={{textAlign:"left",marginTop:"-15px"}} className="col col-lg-5 col-md-6 col-sm-12  col-12 reactstart" ><ReactStars {...secondExample} /></div>

    </div>
    <div className="row ">
<div style={{textAlign:"right"}} className="col col-lg-1 col-md-1 col-sm-2 col-2 numdata">3</div>
<div  className="col col-lg-6 col-md-5 col-sm-10 col-10 rating-line">Quality of Advice & Guidance</div>
<div style={{textAlign:"left",marginTop:"-15px"}} className="col col-lg-5 col-md-6 col-sm-12  col-12 reactstart" ><ReactStars {...thirdExample} /></div>

    </div>
    <div  className="row ">
<div style={{textAlign:"right"}} className="col col-lg-1 col-md-1 col-sm-2 col-2 numdata">4</div>
<div  className="col col-lg-6 col-md-5 col-sm-10 col-10 rating-line ">Quality of Interconnections</div>
<div style={{textAlign:"left",marginTop:"-15px"}} className="col col-lg-5 col-md-6 col-sm-12  col-12 reactstart" ><ReactStars {...fourthExample} /></div>

    </div>
      
       {/* <div className="overall"><span className="num-data1" >1</span><p className="overall-both" >
        <p className="overall-para" > Overall Mentor Rating</p><ReactStars {...firstExample} />
       </p>
       </div>

       <div className="overall"><span className="num-data" >2</span><p className="overall-both" >
        <p className="overall-Behaviour" > Mentor Behaviour & Professionalism</p><ReactStars {...secondExample} />
       </p>
       </div>

       <div className="overall"><span className="num-data" >3</span><p className="overall-both" >
        <p className="overall-Advice" > Quality of Advice & Guidance</p><ReactStars {...thirdExample} />
       </p>
       </div>

       <div className="overall"><span className="num-data" >4</span><p className="overall-both" >
        <p className="overall-Quality" > Quality of Interconnections</p><ReactStars {...fourthExample} />
       </p>
       </div>
       */}
    </div>
   
    <div>
    <Button className="feedback-bttn"
    //  style={{
    //                color: "#3AC2D7",
    //                    marginRight: "8px",
    //                    backgroundColor: "white",
    //                    width: "150px",
    //                    border: "1px solid #00000040",
    //                    marginTop: "20px",
    //               }}
                  variant="outlined">
                    BACK</Button>
    <Button className="feedback-bluebttn"
    //  style={{
    //                 backgroundColor: "#3AC2D7",
    //                 color: "#fff",
    //                 width: "186px",
    //                 marginTop: "20px",
    //               }}
                  variant="outlined" >
                    SAVE & SUBMIT</Button>
    </div>

    </div>
  );
};

const DisplayTextSurface = (props) => {
  const classes = useStyles();
  return (
    <>
      <Box sx={{ position: "relative", width: "100%" }}>
        <Box sx={{ fontSize: "44px", color: "#3AC2D7" }}>{props.content}</Box>
      </Box>
    </>
  );
};

const MentorCard = (props) => {
  const classes = useStyles();

  return (
    <Card elevation={3} className={classes.cardroot}>
      <CardContent className={classes.cardContent}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            padding: "0 13%",
          }}
        >
          <img
            src={mentorimage}
            className={classes.cardImage}
            alt="mentor image"
          />
          <img
            src={orgimage}
            className={classes.cardImage}
            alt="organization image"
          />
        </Box>
        <Typography className={classes.cardText1}>MENTOR MATCH</Typography>
        <DisplayTextSurface content={"91%"} />
        <Typography className={classes.cardText2}>SHRIDHAR RAJAN</Typography>
        <Divider style={{ backgroundColor: "#4cc4d6", height: "4px" }} />
     
      </CardContent>
    </Card>
  );
};

const FeedBack = (props) => {
  const classes = useStyles();

  const [uncollapsedCard, setUncollapsedCard] = useState(null);

  return (
    <Box
      style={{ minHeight: "500px", paddingTop: "30px", background:
      "linear-gradient(0deg, rgba(247,243,255,1) 0%, rgba(217,199,230,0.9082983535210959) 100%)", paddingBottom: "30px" }}
    >
      <Typography className={classes.firstHeading}>
        NATIONAL MENTORSHIP PORTAL
      </Typography>
      <Typography className={classes.secondHeading}>
        FEEDBACK
      </Typography>

      <UpperDisplaySurface />

     
    </Box>
  );
};

export default FeedBack;